<template>
  <v-container fluid class="ma-4 px-8">
    <!-- <v-row justify="start" align="center">
      <v-col cols="12" md="4">
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <label>Date Range</label>
            <v-text-field
              v-model="displayDate"
              readonly
              outlined
              dense
              v-bind="attrs"
              v-on="on"
              hide-details="auto"
            ></v-text-field>
          </template>
          <v-sheet
            class="pa-4"
            elevation="4"
            style="background-color: white; border-radius: 8px"
          >
            <v-row no-gutters>
              <v-col>
                <v-date-picker
                  v-model="selectedDates"
                  range
                  @input="onDateChange"
                ></v-date-picker>
              </v-col>

              <v-col class="pl-4 pt-4" style="max-width: 150px">
                <div
                  v-for="option in dateOptions"
                  :key="option.label"
                  class="mb-2 pt-2"
                >
                  <v-btn small color="accent" @click="setQuickDate(option)">
                    {{ option.label }}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-sheet>
        </v-menu>
      </v-col>

      <v-col cols="12" md="5">
        <v-btn class="accent white--text mt-5" @click="init()"> Search </v-btn>
      </v-col>
    </v-row> -->
    <v-row>
      <v-col cols="12">
        <v-card class="px-6 pt-4" elevation="0">
          <v-row class="align-center justify-between">
            <v-col cols="12" sm="6">
              <h2 class="text-h6">
                Course Completion Rate
                <span v-if="allData && Object.keys(allData).length > 0">
                  - {{ weeks[currentWeekIndex] }}</span
                >
              </h2>
            </v-col>

            <v-spacer></v-spacer>
            <v-col cols="12" sm="3" class="text-right">
              <v-select
                v-model="filteredCourse"
                :items="courses"
                item-text="name"
                item-value="id"
                label="Course"
                dense
                outlined
                hide-details
                class="mt-sm-0 mt-2"
                @change="getFilteredData()"
              />
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <v-row
            align="center"
            justify="center"
            dense
            v-if="allData && Object.keys(allData).length > 0"
          >
            <v-col cols="12" sm="1" class="text-center">
              <v-btn
                icon
                :disabled="currentWeekIndex === 0"
                @click="currentWeekIndex--"
              >
                <v-icon large>mdi-chevron-left-circle</v-icon>
              </v-btn>
            </v-col>

            <v-col cols="12" sm="10">
              <transition name="fade-slide" mode="out-in">
                <div
                  :key="currentWeekIndex"
                  class="d-flex justify-space-around"
                >
                  <v-sheet
                    class="pa-4 rounded-lg elevation-1 text-center"
                    width="45%"
                  >
                    <h4 class="text-subtitle-1 mb-2">Total Courses</h4>
                    <div class="text-h4 font-weight-bold">
                      {{ summaryStats.total }}
                    </div>
                  </v-sheet>

                  <v-sheet
                    class="pa-4 rounded-lg elevation-1 text-center"
                    width="45%"
                  >
                    <h4 class="text-subtitle-1 mb-2">Completion Rate</h4>
                    <div class="text-h4 font-weight-bold">
                      {{ summaryStats.percent }}%
                    </div>
                  </v-sheet>
                </div>
              </transition>
            </v-col>

            <v-col cols="12" sm="1" class="text-center">
              <v-btn
                icon
                :disabled="currentWeekIndex === weeks.length - 1"
                @click="currentWeekIndex++"
              >
                <v-icon large>mdi-chevron-right-circle</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters v-else class="d-flex justify-center pa-6">
            <v-col cols="12" class="d-flex align-center justify-center">
              <v-icon class="mb-2 animated-icon" color="grey lighten-1" large>
                mdi-database-remove
              </v-icon>
            </v-col>
            <v-col class="d-flex align-center justify-center">
              <h3 class="body-1">
                No weekly summary available for the selected course
              </h3>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <template v-for="(d, ind) in courseCompletion">
          <v-card
            class="pa-4 mt-4 widget-style"
            v-if="d.type === 'bar'"
            :key="ind"
            @click="viewData('courseCompletion', 'Course Completion - By week')"
          >
            <h3 class="body-1">{{ d.name }}</h3>
            <BarChartView
              :chartData="d.data"
              :stacked="true"
              :isPercent="true"
            />
          </v-card>
        </template>
      </v-col>
      <v-col cols="12" md="6" v-if="timeSpent && timeSpent.name">
        <v-card
          class="pa-4 mt-4 widget-style"
          @click="viewData('timeSpent', 'Time Spent(Mts) - By course')"
        >
          <h3 class="body-1">{{ timeSpent.name }}</h3>
          <BarChartView :chartData="timeSpent.data" />
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="6"
        v-if="assignmentMarkBased && assignmentMarkBased.name"
      >
        <v-card
          class="pa-4 mt-4 widget-style"
          @click="viewData('assignmentMark', 'Assignment Mark - By course')"
        >
          <h3 class="body-1">{{ assignmentMarkBased.name }}</h3>
          <DoughnutView :chartData="assignmentMarkBased.data" />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LineChartView from "@/components/dashboard/views/lineChartView";
import DoughnutView from "@/components/dashboard/views/doughnutView";
import BarChartView from "@/components/dashboard/views/barChartView";

export default {
  components: {
    LineChartView,
    DoughnutView,
    BarChartView,
  },
  data() {
    return {
      menu: false,
      selectedDates: [],
      displayDate: "",
      form: {
        from_date: "",
        to_date: "",
      },
      dateOptions: [
        { label: "Today", days: 0 },
        { label: "Yesterday", days: 1 },
        { label: "This Week", type: "week" },
        { label: "Last 7 Days", days: 7 },
        { label: "This Month", type: "month" },
        { label: "Last 30 Days", days: 30 },
        { label: "Reset", type: "reset" },
      ],
      courseCompletion: [],
      assignmentMarkBased: {},
      timeSpent: {},
      weeks: [],
      currentWeekIndex: 0,
      selectedCourse: null,
      selectedContentType: null,
      allData: {},
      filteredCourse: "all",
      courses: [
        {
          name: "All Courses",
          id: "all",
        },
        {
          name: "Grammar",
          id: "Grammar",
        },
        {
          name: "Strategic Management",
          id: "Strategic Management",
        },
        {
          name: "Services Marketing & Customer Relationship Management",
          id: "Services Marketing & Customer Relationship Management",
        },
      ],
    };
  },
  computed: {
    currentWeek() {
      return this.weeks[this.currentWeekIndex];
    },
    summaryStats() {
      const weekSummary = this.allData[this.currentWeek];
      if (!weekSummary) return { total: 0, completed: 0, percent: 0 };
      if (!this.selectedCourse) {
        return {
          total: weekSummary.summary.total,
          completed: weekSummary.summary.completed,
          percent: weekSummary.summary.percent,
        };
      }

      const selectedCourseData = weekSummary.courses[this.selectedCourse];
      if (!selectedCourseData || !selectedCourseData.content_types) {
        return { total: 0, completed: 0, percent: 0 };
      }

      const contentTypes = selectedCourseData.content_types;

      if (this.selectedContentType) {
        const ct = contentTypes[this.selectedContentType];
        if (ct) {
          return {
            total: ct.total,
            completed: ct.completed,
            percent: ct.percent,
          };
        } else {
          return { total: 0, completed: 0, percent: 0 };
        }
      }

      // Only course selected → use content types
      let total = 0;
      let completed = 0;

      Object.values(contentTypes).forEach((ct) => {
        total += ct.total;
        completed += ct.completed;
      });

      const percent = total > 0 ? Math.round((completed / total) * 100) : 0;

      return {
        total,
        completed,
        percent,
      };
    },
    allCourses() {
      const weekSummary = this.allData[this.currentWeek];
      if (!weekSummary || typeof weekSummary.courses !== "object") return [];
      return Object.keys(weekSummary.courses);
    },
  },

  created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Dashboard" }]);
    this.init();
  },
  methods: {
    async init() {
      await Promise.all([this.getDashboard(this.filteredCourse)]);
    },
    async getDashboard(course) {
      await this.$axios
        .get(`/get_dashboard?course=${encodeURIComponent(course)}`)
        .then((res) => {
          this.courseCompletion = res.data.data.course_completion;
          this.timeSpent = res.data.data.time_spent_by_course;
          this.assignmentMarkBased = res.data.data.assignment_mark_based;
          const tableData = this.courseCompletion.find(
            (item) => item.type === "table"
          );
          this.allData = tableData ? tableData.data : {};

          this.weeks = Object.keys(this.allData);
          this.currentWeekIndex = this.weeks.length - 1;
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    viewData(key, title) {
      this.$router.push({
        name: "Dashboard View",
        query: {
          key: key,
          title: title,
          course: this.filteredCourse,
        },
      });
    },
    getFilteredData() {
      this.getDashboard(this.filteredCourse);
    },
  },
};
</script>

<style scoped>
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
}
.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateX(5px);
}
</style>
